import React from "react";

/**
 * FlowerShapes — renders one flower template's baked draw primitives (from
 * flowerScatter.js's makeFlower): the petal ring as a filled arc-path, leaves
 * as filled ellipses, the centre as a filled circle, and the stem as a stroked
 * path. Shared by FlowerTurf (the home meadow) and EdgeFlowers (the game-screen
 * frame) so the shape → SVG mapping lives in one place.
 *
 * Primitives carry semantic ROLES, not colours: fills resolve through CSS
 * custom properties so the whole meadow retunes from theme.css. The greens map
 * straight to theme variables; --petal-fill/--petal-fold are set per <use> by
 * its bloom class (FlowerField.css) and inherit into the use shadow tree. The
 * vars MUST be applied via `style` — as a presentation ATTRIBUTE, fill="var(…)"
 * is dropped by browsers.
 */
const ROLE_FILLS = {
  petal: { fill: "var(--petal-fill)" },
  fold: { fill: "var(--petal-fold)" },
  leafLight: { fill: "var(--color-primary-light)" },
  leafDark: { fill: "var(--color-primary-dark)" },
};
const STEM_STROKE = { stroke: "var(--color-primary)" };

export default function FlowerShapes({ shapes }) {
  return shapes.map((s, i) => {
    if (s.t === "e")
      return (
        <ellipse
          key={i}
          cx={s.cx}
          cy={s.cy}
          rx={s.rx}
          ry={s.ry}
          style={ROLE_FILLS[s.role]}
          transform={s.rot ? `rotate(${s.rot} ${s.cx} ${s.cy})` : undefined}
        />
      );
    if (s.t === "c") return <circle key={i} cx={s.cx} cy={s.cy} r={s.r} style={ROLE_FILLS[s.role]} />;
    if (s.t === "p") return <path key={i} d={s.d} style={ROLE_FILLS[s.role]} />;
    return (
      <path key={i} d={s.d} fill="none" style={STEM_STROKE} strokeWidth={s.w} strokeLinecap="round" />
    );
  });
}
